import { UseQueryResult, useQuery } from 'react-query';

import api from '@root/api';

const useListCreditRecords = <T = any>(): UseQueryResult<T, Error> => {
  return useQuery(['usage.listCreditRecords'], () => api.usage.listCredits(), { refetchOnMount: 'always' });
};

export default useListCreditRecords;
